// Cloud Modernization Services content
export const cloudServices = [
  {
    id: 'strategy',
    title: 'Cloud Strategy & Modernization Roadmap',
    icon: 'Route',
    tagline: 'A clear roadmap aligned with your business goals.',
    features: [
      'Cloud readiness assessment',
      'Application portfolio analysis',
      'Infrastructure assessment',
      'Cost optimization planning',
      'Cloud migration strategy',
      'Technology roadmap',
      'Business case development',
      'Modernization workshops'
    ]
  },
  {
    id: 'apps',
    title: 'Application Modernization',
    icon: 'Code2',
    tagline: 'Transform legacy apps into scalable cloud-native solutions.',
    features: [
      'Legacy application modernization',
      'Microservices architecture',
      'API modernization',
      'Containerization',
      'Kubernetes implementation',
      'Serverless architecture',
      'Re-platforming & refactoring',
      'DevSecOps integration'
    ]
  },
  {
    id: 'infra',
    title: 'Infrastructure Modernization',
    icon: 'Server',
    tagline: 'Higher availability, stronger security, greater efficiency.',
    features: [
      'Infrastructure transformation',
      'Hybrid cloud architecture',
      'Multi-cloud strategy',
      'Infrastructure as Code (Terraform, CFN)',
      'Cloud automation',
      'Virtualization modernization',
      'Network modernization',
      'Storage optimization'
    ]
  },
  {
    id: 'migration',
    title: 'Cloud Migration Services',
    icon: 'CloudUpload',
    tagline: 'Move to the cloud with confidence and minimal downtime.',
    features: [
      'AWS Cloud Migration',
      'Azure Migration',
      'Google Cloud Migration',
      'Data center migration',
      'VMware migration',
      'Database migration',
      'Storage migration',
      'Lift-and-shift & optimization'
    ]
  },
  {
    id: 'data',
    title: 'Data Modernization',
    icon: 'Database',
    tagline: 'Intelligent, accessible, and secure data platforms.',
    features: [
      'Data lake implementation',
      'Data warehouse modernization',
      'Data integration',
      'Data governance',
      'Data quality management',
      'Real-time analytics',
      'Business intelligence',
      'AI-ready data platforms'
    ]
  },
  {
    id: 'devsecops',
    title: 'DevSecOps & Automation',
    icon: 'Rocket',
    tagline: 'Ship faster with enterprise-grade security baked in.',
    features: [
      'CI/CD pipeline implementation',
      'Infrastructure automation',
      'Security automation',
      'Monitoring & observability',
      'Continuous compliance',
      'Configuration management',
      'Release automation'
    ]
  },
  {
    id: 'finops',
    title: 'Cloud Cost Optimization',
    icon: 'PiggyBank',
    tagline: 'Reduce cloud spend without compromising performance.',
    features: [
      'Cloud cost assessment',
      'Resource optimization',
      'Rightsizing',
      'Reserved instance planning',
      'FinOps advisory',
      'Cloud governance',
      'Budget forecasting',
      'Cost monitoring dashboards'
    ]
  }
];

export const cloudFramework = [
  { step: '01', title: 'Discover', description: 'Assess your current applications, infrastructure, data, security posture, and business objectives.' },
  { step: '02', title: 'Design', description: 'Develop a tailored modernization strategy with measurable milestones and a clear migration roadmap.' },
  { step: '03', title: 'Modernize', description: 'Modernize applications, infrastructure, and operations using cloud-native tech, automation, and best practices.' },
  { step: '04', title: 'Migrate', description: 'Execute secure, seamless migrations while minimizing disruption to business operations.' },
  { step: '05', title: 'Optimize', description: 'Continuously optimize performance, security, availability, and cloud costs to maximize long-term value.' }
];

export const cloudBenefits = [
  { title: 'Accelerate digital transformation', icon: 'Rocket' },
  { title: 'Improve application performance', icon: 'Gauge' },
  { title: 'Enhance security & compliance', icon: 'ShieldCheck' },
  { title: 'Increase agility & scalability', icon: 'TrendingUp' },
  { title: 'Reduce infrastructure costs', icon: 'PiggyBank' },
  { title: 'Enable AI & advanced analytics', icon: 'Brain' },
  { title: 'Strengthen disaster recovery', icon: 'LifeBuoy' },
  { title: 'Improve customer experiences', icon: 'Heart' },
  { title: 'Boost developer productivity', icon: 'Code2' },
  { title: 'Support continuous innovation', icon: 'Sparkles' }
];

export const cloudWhyChoose = [
  { title: 'Cloud-First Expertise', description: 'Consultants specialized in designing modern, secure, scalable, future-ready cloud environments.', icon: 'Cloud' },
  { title: 'AI-Driven Innovation', description: 'We combine cloud modernization with AI and automation to create intelligent business platforms.', icon: 'Sparkles' },
  { title: 'Business-Focused Transformation', description: 'Every initiative aligned with your business objectives, delivering measurable outcomes.', icon: 'Target' },
  { title: 'End-to-End Delivery', description: 'Strategy, assessment, migration, optimization, and ongoing managed services — one partner.', icon: 'GitBranch' },
  { title: 'Security by Design', description: 'Governance, compliance, and resilience embedded from day one of every engagement.', icon: 'Lock' }
];

export const cloudTechnologies = [
  'AWS', 'Microsoft Azure', 'Google Cloud (GCP)', 'VMware', 'Kubernetes', 'Docker',
  'Terraform', 'AWS CloudFormation', 'Amazon ECS & EKS', 'AWS Lambda', 'Amazon Bedrock',
  'GitHub Actions', 'Jenkins', 'Ansible', 'Prometheus', 'Grafana', 'OpenTelemetry'
];

export const cloudIndustries = [
  { name: 'Retail & FMCG', icon: 'ShoppingBag' },
  { name: 'Banking & Financial Services', icon: 'Landmark' },
  { name: 'Real Estate & Construction', icon: 'Building2' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Healthcare', icon: 'HeartPulse' },
  { name: 'Hospitality', icon: 'Hotel' },
  { name: 'Logistics & Supply Chain', icon: 'Truck' },
  { name: 'Government & Public Sector', icon: 'Landmark' },
  { name: 'Education', icon: 'GraduationCap' },
  { name: 'Media & Entertainment', icon: 'Film' }
];

export const cloudFaqs = [
  { q: 'What is cloud modernization?', a: 'The process of transforming legacy applications, infrastructure, and data into modern, cloud-native environments that improve performance, security, scalability, and operational efficiency.' },
  { q: 'How is cloud modernization different from cloud migration?', a: 'Migration focuses on moving workloads to the cloud. Modernization goes further by redesigning applications, infrastructure, and processes to fully leverage cloud-native capabilities and deliver long-term business value.' },
  { q: 'Can we modernize without disrupting business operations?', a: 'Yes. We follow a phased modernization approach that minimizes downtime, reduces risk, and ensures business continuity throughout the transformation journey.' },
  { q: 'Which cloud platforms do you support?', a: 'We support Amazon Web Services (AWS), Microsoft Azure, Google Cloud Platform (GCP), and hybrid or multi-cloud environments.' }
];
